import DocumentViewer from './document-viewer.vue'

/**
 * Common UI components
 */
export default {
  'artup-document-viewer': DocumentViewer
}
